import { Phone, Mail, MessageCircle } from "lucide-react";

const initials = (name = "") => name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("") || "G";
const waNumber = (p = "") => p.replace(/[^\d]/g, "");

/** Guest identity strip: avatar, name, mobile, email + Call / WhatsApp quick links. */
export function GuestInfoStrip({ name, phone, email, right = null, compact = false, testid = "guest-info-strip" }) {
  return (
    <div data-testid={testid} className={`flex items-center gap-4 rounded-lg border border-[#D5E6E8] bg-white ${compact ? "px-4 py-3" : "px-5 py-4"}`}>
      <div className={`${compact ? "w-9 h-9 text-[13px]" : "w-10 h-10 text-[14px]"} shrink-0 rounded-full bg-[#014751] text-white on-dark font-bold flex items-center justify-center`} data-testid={`${testid}-avatar`}>
        {initials(name)}
      </div>
      <div className="min-w-0 flex-1">
        <div className={`${compact ? "text-[15px]" : "text-[16px]"} font-bold text-[#1A2425] truncate`} data-testid={`${testid}-name`}>{name || "Guest"}</div>
        <div className="flex flex-wrap gap-x-4 gap-y-0.5 mt-0.5">
          <span className="inline-flex items-center gap-1.5 text-[13px] text-[#3F5257]" data-testid={`${testid}-phone`}>
            <Phone size={13} strokeWidth={1.75} className="text-[#97A6A9]" />{phone || <span className="text-[#97A6A9]">No mobile on file</span>}
          </span>
          {email && (
            <span className="inline-flex items-center gap-1.5 text-[13px] text-[#3F5257] truncate" data-testid={`${testid}-email`}>
              <Mail size={13} strokeWidth={1.75} className="text-[#97A6A9]" />{email}
            </span>
          )}
        </div>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        {phone && (
          <>
            <a href={`tel:${phone}`} className="inline-flex items-center gap-1 text-[13px] font-semibold text-[#014751] hover:underline" data-testid={`${testid}-call`}>
              <Phone size={13} strokeWidth={1.75} />Call
            </a>
            <a href={`https://wa.me/${waNumber(phone)}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[13px] font-semibold text-[#014751] hover:underline" data-testid={`${testid}-message`}>
              <MessageCircle size={13} strokeWidth={1.75} />Message
            </a>
          </>
        )}
        {right}
      </div>
    </div>
  );
}
